class SearchBoxHelper {
    constructor() {

    }

    animate() {
        // Animate the search box
        var searchToggle = document.getElementById("search-toggle");
        searchToggle.addEventListener("click", function (e) {
            if (searchToggle.classList.contains("not-active")) {
                //console.log("CLICKED!");
                $('.top_nav .navbar-nav').addClass('add-margin');
                $('.search-toggle').removeClass('not-active');
                $('.search-toggle').addClass('active');
                $('.search-toggle').addClass('animate-text');
                setTimeout(function () {
                    $('.search-toggle').addClass('remove-text');
                    $('.search-toggle').addClass('add-input');
                }, 200);
                setTimeout(function () {
                    $('.search-toggle').addClass('animate-input');
                }, 310);
                setTimeout(function () {
                    $('.search-toggle').addClass('animate-input-width');
                }, 320);
            }
        });
        searchToggle.addEventListener("keypress", function (e) {
            if (e.key === 'Enter') {
                if (searchToggle.classList.contains("not-active")) {
                    //console.log("CLICKED!");
                    $('.top_nav .navbar-nav').addClass('add-margin');
                    $('.search-toggle').removeClass('not-active');
                    $('.search-toggle').addClass('active');
                    $('.search-toggle').addClass('animate-text');
                    setTimeout(function () {
                        $('.search-toggle').addClass('remove-text');
                        $('.search-toggle').addClass('add-input');
                    }, 200);
                    setTimeout(function () {
                        $('.search-toggle').addClass('animate-input');
                    }, 310);
                    setTimeout(function () {
                        $('.search-toggle').addClass('animate-input-width');
                    }, 320);
                }
            }
        });
        var closeToggle = document.getElementById("closeToggle");
        closeToggle.addEventListener("click", function (e) {
            if (searchToggle.classList.contains("active")) {
                //console.log("CLICKED CLOSE!");
                $('.search-toggle').removeClass('animate-input-width');
                $('.search-toggle').removeClass('animate-input');
                setTimeout(function () {
                    $('.search-toggle').removeClass('add-input');
                    $('.search-toggle').removeClass('remove-text');
                }, 300);
                setTimeout(function () {
                    $('.search-toggle').removeClass('animate-text');
                    $('.search-toggle').removeClass('active');
                    $('.search-toggle').addClass('not-active');
                    $('.top_nav .navbar-nav').removeClass('add-margin');
                }, 310);
            }
        });
        closeToggle.addEventListener("keypress", function (e) {
            if (e.key === 'Enter') {
                if (searchToggle.classList.contains("active")) {
                    //console.log("CLICKED CLOSE!");
                    $('.search-toggle').removeClass('animate-input-width');
                    $('.search-toggle').removeClass('animate-input');
                    setTimeout(function () {
                        $('.search-toggle').removeClass('add-input');
                        $('.search-toggle').removeClass('remove-text');
                    }, 300);
                    setTimeout(function () {
                        $('.search-toggle').removeClass('animate-text');
                        $('.search-toggle').removeClass('active');
                        $('.search-toggle').addClass('not-active');
                        $('.top_nav .navbar-nav').removeClass('add-margin');
                    }, 310);
                }
            }
        });

    }
}

window.app.add('searchBox', new SearchBoxHelper());